"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandAcquisitionSource = exports.CommandFormEmbedVersion = exports.CommandLang = exports.CommandStatus = exports.CommandSource = void 0;
var CommandSource;
(function (CommandSource) {
    CommandSource["FormSubmission"] = "FormSubmission";
    CommandSource["ManualEntry"] = "ManualEntry";
    CommandSource["Import"] = "Import";
    CommandSource["PublicApi"] = "PublicApi";
})(CommandSource || (exports.CommandSource = CommandSource = {}));
var CommandStatus;
(function (CommandStatus) {
    CommandStatus["Open"] = "open";
    CommandStatus["Submitted"] = "submitted";
    CommandStatus["Validated"] = "validated";
    CommandStatus["Complete"] = "complete";
    /** @deprecated - do not use anymore, manual command removed are fully deleted instead */
    CommandStatus["Archived"] = "archived";
    CommandStatus["Failed"] = "failed";
    CommandStatus["Expired"] = "expired";
})(CommandStatus || (exports.CommandStatus = CommandStatus = {}));
var CommandLang;
(function (CommandLang) {
    CommandLang["EN"] = "EN";
    CommandLang["FR"] = "FR";
    CommandLang["ES"] = "ES";
    CommandLang["DE"] = "DE";
})(CommandLang || (exports.CommandLang = CommandLang = {}));
var CommandFormEmbedVersion;
(function (CommandFormEmbedVersion) {
    CommandFormEmbedVersion["EmbedV1"] = "EmbedV1";
    CommandFormEmbedVersion["EmbedV2"] = "EmbedV2";
})(CommandFormEmbedVersion || (exports.CommandFormEmbedVersion = CommandFormEmbedVersion = {}));
var CommandAcquisitionSource;
(function (CommandAcquisitionSource) {
    CommandAcquisitionSource["OrganizationPage"] = "OrganizationPage";
})(CommandAcquisitionSource || (exports.CommandAcquisitionSource = CommandAcquisitionSource = {}));
